import TYPES from '../../action-types';
import SHARED_CONSTANTS from '../../../shared/constants';
import mergeKeywordsPreservingSources from '../../helpers/assets/mergeKeywordsPreservingSources';

const { METADATER: METADATER_USER_ID } = SHARED_CONSTANTS.systemUsers;

function parseFields(asset, keywordsStore, existingKeywords = []) {
  const fields = ['metadating'];
  const values = ['complete'];

  if ('title' in asset) {
    fields.push('title');
    values.push(asset.title);
  }
  if ('description' in asset) {
    fields.push('description');
    values.push(asset.description);
  }
  if ('color' in asset) {
    fields.push('color');
    values.push(asset.color);
  }
  if ('rating' in asset) {
    fields.push('rating');
    values.push(asset.rating);
  }
  if ('flag' in asset) {
    fields.push('flag');
    values.push(asset.flag);
  }
  if ('keywords' in asset) {
    const keywordsIds = asset.keywords.map(({ _id }) => _id);
    const keywords = keywordsStore.all.filter((keyword) => keywordsIds.includes(keyword._id));
    const metadaterKeywords = keywords.map((k) => ({ ...k, attachedBy: METADATER_USER_ID }));
    fields.push('keywords');
    values.push(mergeKeywordsPreservingSources(existingKeywords, metadaterKeywords, METADATER_USER_ID));
  }
  if ('meta' in asset) {
    fields.push('meta');
    values.push(asset.meta);
  }

  return { fields, values };
}

/**
 * @param {Array} receivedAssets
 */
function metadatingComplete(receivedAssets = []) {
  return (dispatch, getState) => {
    const { keywords: keywordsStore, assets: assetsStore } = getState();

    const assets = receivedAssets.map((asset) => {
      const existingKeywords = assetsStore.items.find(({ _id }) => _id === asset._id)?.keywords || [];
      const { fields, values } = parseFields(asset, keywordsStore, existingKeywords);
      return {
        _id: asset._id,
        fields,
        values,
      };
    });

    dispatch({
      type: TYPES.ASSETS.UPDATE_FIELDS_MANY_ASSETS,
      payload: { assets },
    });
  };
}

export default metadatingComplete;
export { parseFields };
